import {
    loginRegistrationDefinition,
    logoutRegistrationDefinition,
    startBreakRegistrationDefinition,
} from 'app/shared/components/system-and-break-activity/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { isSupportedBreakActivity } from 'app/shared/features/activity-selector/utils';

import { TimeRegistrationCode, timeRegistrationCode } from '../models';

/** There's 2 way to check if activity is type Login/Logout/StartBreak:
 * 1. By activity: Activity number is 0 and name matches one of the time registration codes (Login/Logout/StartBreak)
 * 2. By scanned code: It contains isSystemCode property
 */
const isSystemActivity = (activityName: string, activityNumber: number) => {
    return isSystemActivityCodeValid(activityName) && activityNumber === 0;
};

export const isSystemActivityCodeValid = (value: string | undefined): value is TimeRegistrationCode => {
    if (!value) return false;
    return timeRegistrationCode.some((code) => code === value.toLowerCase());
};

/**
 * Time registration activities can be either:
 * - system activities (Login/Logout/StartBreak)
 * - supported break activities
 *
 * @param activityName
 * @param activityNumber
 * @param breakActivity
 */
export const isSystemOrBreakActivity = (
    activityName: string,
    activityNumber: number,
    breakActivity: Activity,
) => {
    return isSystemActivity(activityName, activityNumber) || isSupportedBreakActivity(breakActivity);
};

export const getTimeRegistrationCodeTitle = (code: TimeRegistrationCode) => {
    switch (code.toLowerCase()) {
        case 'login':
            return loginRegistrationDefinition.name;
        case 'logout':
            return logoutRegistrationDefinition.name;
        case 'startbreak':
            return startBreakRegistrationDefinition.name;
        default:
            return undefined;
    }
};
